<template>
    <nav  :class="'navbar is-fixed-bottom '+classEpire_c" role="navigation" aria-label="main navigation">
         
         <div :class="tournoi.options.delay=='FREE' && tournoi.state!='EXPIRE' && tournoi.state!='FINISH' 
            ? 'navbar-brand free' : 'navbar-brand'"> 
        <div class="navbar-item" style="width:100%" >
            <div v-if="tournoi">
              
            <div v-if="tournoi.state=='EXPIRE'">
                Ce tournoi a expiré. <br/>
                Vous pouvez le prolonger si vous souhaitez continuer...
            </div>  
            <div v-if="tournoi.expire!=null && tournoi.state!='EXPIRE' ">  
                <div class="expire">
                    Ce tournoi expire le {{formatDate}} à {{formatHeure}}<br/>
                    Il reste {{compteAReboursDataD}} jours et {{compteAReboursDataH}}h : {{compteAReboursDataM}}m : {{compteAReboursDataS}}s
                    
                </div>
            </div>
            <div v-if="tournoi.state=='INSCRIPTION' && tournoi.expire==null">  
                    La formule choisie est <b style="font-size:20px">
                        {{tournoi.options.delay == 'FREE' ? 'TEST' : tournoi.options.delay }}
                        </b><br/>
                    <div class="marquee-rtl">
                   
                    <div> Dès que vous allez démarrer le tournoi, il expiera dans <b style="color:rgb(129, 1, 1)">{{delay}}</b>. Vous pourrez prolonger la durée une fois que le tournoi sera démarré
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
         </div>
    </nav>
</template>
<style scoped>
    .free {
        background-color:rgb(250, 162, 243);
        width:100%
    }
    .expire {
        font-weight: bold;
        font-size: 13px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .Aexpire {
        font-weight: bold;
        font-size: 13px;
        padding-left: 10px;
        padding-right: 10px;
        color: rgb(43, 42, 42);
        background-color: rgb(214, 36, 36);
    } 
    .expireBientot {
        font-weight: bold;
        font-size: 13px;
        padding-left: 10px;
        padding-right: 10px;
        color: white;
        background-color: rgb(214, 36, 36);

    }
        /* ---------------------------- */
    /* Défilement de droite à gauche */
    .marquee-rtl {
        overflow: hidden; /* important */
        width:100%; 
        min-width: 300px; /* A ADAPTER */
    }
    .marquee-rtl > div {
        display: inline-block; /* important */
        white-space: nowrap; /* important */
        animation: defilement-rtl 15s infinite linear; /* défilement */
        cursor: pointer;
    }
    .marquee-rtl:hover > div {
        animation-play-state: paused; /* met en pause le défilement */
    }
    
    @keyframes defilement-rtl {
    0% {
        -webkit-transform: translate(100%);
        transform: translate(100%);
    }
    100% {
        -webkit-transform: translate(-100%);
        transform: translate(-100%);
    }
    }
    /* ---------------------------- */
    /* texte sur plusieurs lignes automatiquement */
    .marquee-multi-lignes > div { 
        width:90%; 
        white-space: normal; /* important */
    }

    /* ---------------------------- */
    /* déco */
    h2, p { text-align:center; }

    .marquee-rtl {
        
    }
    .marquee-rtl > div {
        font-size: 16px;
    }
</style>
<script>
import tournoi_fct from "@/firebase/tournoi"
export default {
    props: ["club", "tournoi"],
    data() {
        return {
            compteAReboursDataD: null,
            compteAReboursDataH: null,
            compteAReboursDataM: null,
            compteAReboursDataS: null,
            classExpire: "is-light",
            timeOut : null
        }
    },
    computed: {
        classEpire_c: {
            get() {
                if (this.tournoi.state == "EXPIRE")
                    return "Aexpire";
                else
                    return this.classExpire;
            }
        },
        formatDate: {
            get() {
                var options = { year: "2-digit", month: "2-digit", day: "2-digit"};
                return (new Date(this.tournoi.expire)).toLocaleString("fr-Fr",options);
            }
        },
        formatHeure: {
            get() {
                 var dateData = new Date(this.tournoi.expire);
                if (dateData.getMinutes()<10)
                    var minutes = "0" + dateData.getMinutes();
                else    
                    var minutes = dateData.getMinutes();
                return (dateData.getHours() + ":" + minutes)
            }
        },
        delay: {
                get() {
                    switch (this.tournoi.options.delay) {
                    case "FREE":
                        return "15 minutes"
                        break;
                    case "8H":
                        return "8 heures"
                        break;
                    case "3J" :
                        return "3 jours"
                        break;  
                    case "5J" :
                        return "5 jours"
                        break;  
                    default:
                        break;
                }
            }
            
        }
    },
    methods: {
        
         dateDiff(date1,date2) {
             var diff = {}                           // Initialisation du retour
                var tmp = date2 - date1;
            
                tmp = Math.floor(tmp/1000);             // Nombre de secondes entre les 2 dates
                diff.sec = tmp % 60;                    // Extraction du nombre de secondes
            
                tmp = Math.floor((tmp-diff.sec)/60);    // Nombre de minutes (partie entière)
                diff.min = tmp % 60;                    // Extraction du nombre de minutes
            
                tmp = Math.floor((tmp-diff.min)/60);    // Nombre d'heures (entières)
                diff.hour = tmp % 24;                   // Extraction du nombre d'heures
                
                tmp = Math.floor((tmp-diff.hour)/24);   // Nombre de jours restants
                diff.day = tmp;
                
                return diff;
        },
        compteARebours() {
           if (this.tournoi.state == "INSCRIPTION" || this.tournoi.state=="INPROGRESS") {
            if (this.tournoi.expire != null) {
               
                var dateCourante = new Date();
                var datePlanifie = new Date(this.tournoi.expire);
                var dateConstruct = new Date (
                        datePlanifie.getFullYear(),
                        datePlanifie.getMonth(),
                        datePlanifie.getDate(),
                        datePlanifie.getHours(),
                        datePlanifie.getMinutes(),
                        0)
                var compare = dateConstruct - dateCourante;
                var diff = this.dateDiff(dateCourante, dateConstruct );
                
                if (compare < (60 * 3 * 1000)) {
                    this.classExpire = "is-danger"
                }
                if (compare < 0) {
                this.tournoi.state = "EXPIRE";
                clearTimeout(this.timeOut);
                tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                    this.$emit("expire");
                })
                }
                else {
                    this.compteAReboursDataD = diff.day; 
                    this.compteAReboursDataH = diff.hour; 
                    this.compteAReboursDataM = diff.min;
                    this.compteAReboursDataS = diff.sec;
                    this.timeOut = setTimeout(
                        ()=>{
                            this.compteARebours()
                        },
                        1000
                    )
                }
            }
        }
        }
    },
    mounted() {
        this.compteARebours();
        
        
    }
}
</script>